import DiscourseRoute from "discourse/routes/discourse";

export default class Docs extends DiscourseRoute {}
